/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormAssignment = {
    status: FormAssignment.status;
    assignedAt: string;
    expiresAt?: string | null;
    reminderAt?: string | null;
    reminderSentAt?: string | null;
    completedAt?: string | null;
    /**
     * Fill URL when the assignment is still open
     */
    linkUrl?: string | null;
    id: number;
    clientId: number;
    clientFirstName: string;
    clientLastName: string;
    formId: number | null;
    formName: string;
};
export namespace FormAssignment {
    export enum status {
        OPEN = 'open',
        COMPLETED = 'completed',
        EXPIRED = 'expired',
    }
}

